export default "__VITE_ASSET__BnTjMqwo__"